import throttle from 'lodash.throttle';
import { gsap } from "gsap";

export default class StickyMenu {

    constructor(el) {

		let mm = gsap.matchMedia();

		mm.add({
			isMobile: `(max-width: 768px)`,
            isDesktop: `(min-width: 1100px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
			}, (context) => {

				let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

				this.el = el;

				this.mayStick = false;
				this.scrolledUp = false;
				this.headerSticky = false;
				this.headerAnimating = false;

				document.addEventListener('scroll',	throttle(
					e => this.checkScroll(),
					100),
				);

				this.prevScroll = 0;

				this.checkScroll();

				const stickLoop = () => {
					if(this.mayStick) {
						if(this.scrolledUp) {
							this.stickHeader();
						} else {
							this.unStickHeader();
						}
						this.prevScroll = window.scrollY;
					} else {
						this.swapHeader();
					}
					requestAnimationFrame(stickLoop);
				};

				stickLoop();

			}
		);
    }

	checkScroll() {
		window.scrollY > 0 ? this.mayStick = true : this.mayStick = false;

		if(this.prevScroll>window.scrollY) {
			this.scrolledUp = true;
		}
		if(this.prevScroll<window.scrollY) {
			this.scrolledUp = false;
		}

		this.prevScroll = window.scrollY;
	}

	stickHeader() {
		if(this.headerAnimating || this.headerSticky) {
			return;
		}

		this.headerAnimating = true;
		this.headerSticky = true;
		document.body.classList.add('page-header--menu-sticky');

		gsap.fromTo(this.el,
			{
				translateY: '0%',
			}, {
				translateY: '100%',
				duration: 0.3,
				onComplete: () => {
					this.headerAnimating = false;
				}
        	}
		);
	}

	unStickHeader() {
		if(this.headerAnimating || !this.headerSticky) {
			return;
		}

		this.headerAnimating = true;

		gsap.fromTo(this.el,
			{
				translateY: '100%',
			}, {
				translateY: '0%',
				duration: 0.5,
				onComplete: () => {
					document.body.classList.remove('page-header--menu-sticky');
					this.headerAnimating = false;
					this.headerSticky = false;
				}
        	}
		);
	}

	swapHeader() {
		if(this.menuOpen||this.headerAnimating||!this.headerSticky) {
			return;
		}

		this.headerAnimating = true;
		gsap.fromTo(this.el,
			{
				translateY: '100%',
			}, {
				translateY: '0%',
				duration: 0,
				onComplete: () => {
					document.body.classList.remove('page-header--menu-sticky');

					gsap.fromTo(this.el,
						{
							opacity: 0,
						}, {
							opacity: 1,
							duration: 0,
							onComplete: () => {
								this.headerAnimating = false;
								this.headerSticky = false;
							}
						}
					);
				}
        	}
		);
	}
}